export default "__VITE_ASSET__B_to2M4k__"